import { LangageIso6391, RDUEComplianceStatus } from "@tfg/db"
import { z } from "zod"

import { CountryIso3166Schema } from "@tfg/types/schemas/enum"

export const fetchDataOptionsSchema = z.object({
  pageIndex: z.coerce.number(),
  pageSize: z.coerce.number(),
})
export type fetchDataOptionsValidationType = z.infer<
  typeof fetchDataOptionsSchema
>

export type fetchDataOptionsParam = {
  fetchDataOptions: fetchDataOptionsValidationType
}

export const filtersSchema = z
  .object({
    search: z.string().optional(),
    agecCompliance: z.enum(["yes", "no"]),
    type: z.string(),
    collection: z.string(),
    supplierContact: z.string(),
    brand: z.string(),
    standardId: z.coerce.number(),
    companyId: z.string().uuid(),
    country: CountryIso3166Schema,
    incomingLaunchDate: z.enum(["incoming", "expired", "all"]),
    duplicateSites: z.enum(["redundant", "all"]),
  })
  .partial()
export type filtersValidationType = z.infer<typeof filtersSchema>

export const filtersRdueSchema = z.object({
  search: z.string().optional(),
  rdueCompliance: z.nativeEnum(RDUEComplianceStatus).optional(),
  type: z.string().optional(),
  collection: z.string().optional(),
  brand: z.string().optional(),
  companyId: z.string().uuid().optional(),
  country: CountryIso3166Schema.optional(),
})
export type filtersRdueValidationType = z.infer<typeof filtersRdueSchema>

export const getProductsSchema = z.object({
  fetchDataOptions: fetchDataOptionsSchema,
  filters: filtersSchema.optional(),
})
export type getProductsValidationType = z.infer<typeof getProductsSchema>

export const getProductsRdueSchema = z.object({
  fetchDataOptions: fetchDataOptionsSchema,
  filters: filtersRdueSchema.optional(),
})
export type getProductsRdueValidationType = z.infer<typeof getProductsSchema>

export const getProductsExportSchema = z.object({
  filters: filtersSchema.optional(),
})

export type getProductsExportValidationType = z.infer<
  typeof getProductsExportSchema
>

export const LanguageIso6391Scehma = z.nativeEnum(LangageIso6391)
export const acceptLanguageHeaderSchema = z.object({
  "accept-language": LanguageIso6391Scehma,
})

export type acceptLanguageHeaderType = z.infer<
  typeof acceptLanguageHeaderSchema
>

export const exportCertificatesSchema = z.object({
  filters: filtersSchema.optional(),
})
export type exportCertificatesValidationType = z.infer<
  typeof exportCertificatesSchema
>

export const updateAgecShowSchema = z.object({
  agecShow: z.boolean(),
})
export type updateAgecShowValidationType = z.infer<typeof updateAgecShowSchema>

export const bulkUpdateAgecShowSchema = z.object({
  productIds: z.array(z.number()),
  agecShow: z.boolean(),
})
export type bulkUpdateAgecShowValidationType = z.infer<
  typeof bulkUpdateAgecShowSchema
>

export const bulkLaunchEcobalyseAnalysisSchema = z.union([
  z.object({
    productIds: z.undefined(),
    organizationId: z.number(),
  }),
  z.object({
    productIds: z.array(z.number()),
    organizationId: z.undefined(),
  }),
])
export type bulkLaunchEcobalyseAnalysisType = z.infer<
  typeof bulkLaunchEcobalyseAnalysisSchema
>
